import React from 'react';
import { Modal as AntdModal } from 'antd';
import './style.scss';

const Modal = ({ title, visible, width, footerComponent, onCancel, children }) => {
  return (
    <AntdModal
      title={title}
      className="admin-modal"
      visible={visible}
      destroyOnClose={true}
      width={width}
      // onOk={handleOk}
      onCancel={onCancel}
      footer={footerComponent}
    >
      {children}
    </AntdModal>
  );
};

export default Modal;
